<template>
    <div class="content-wrapper">
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-4">
                        <h1 class="m-0 text-dark">Issue Fix</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-8">
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="form-group">
                                            <label for="order_id">{{ $t('globalTrans.order_id') }}</label>
                                            <input type="text" id="order_id" class="form-control" placeholder="Order ID" v-model="search.order_id">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group" style="margin-top:30px;">
                                            <button class="btn btn-info btn-sm mr-2" type="submit" @click.prevent="submitOrder">Submit</button>
                                            <button class="btn btn-warning btn-sm" @click.prevent="reload"><i class="fa fa-sync-alt"></i></button>
                                            <slot v-if="loading">
                                                <div class="ml-1 spinner-border spinner-border-sm text-success" role="status"></div>
                                            </slot>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
    </div>
</template>
<script>
    import config from '@/config'
    export default {
        name:'ChargeAdjust',
        data () {
            return {
                bulkModal: 0,
                loading: false,
                search : {
                    order_id: ''
                },
                form: null,
                exchangeList: [
                    { id: 1, text: 'Yes' },
                    { id: 2, text: 'NO' },
                ],
                divisionList: [],
                districtList: [],
                thanaList: [],
                zoneList: [],
                areaList: []
            }
        },
        watch: {
            'form.coverage_area_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.divisionList = this.getDivisionList(newVal)
                    // this.districtList = this.getDistrictByCoverage(newVal)
                }
            },
            'form.division_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.districtList = this.getDistrictList(newVal)
                }
            },
            'form.district_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.thanaList = this.getThanaList(newVal)
                }
            },
            'form.thana_id': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    // this.zoneList = this.getZoneList(newVal)
                    this.areaList = this.getAreaList(newVal)
                }
            },
            'form.weight': function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.form.weight_charge = this.getWeightCharge(newVal)
                }
            },
        },
        computed : {
            authUser () {
                return this.$store.state.authUser
            },
            customState () {
                return this.$store.state
            },
            commonObj () {
                return this.$store.state.commonObj
            }
        },
        methods:{
            async submitOrder () {
                this.loading = true
                const response = await config.postData(`/order/trash-order-fix`, this.search)
                this.loading = false
                if (response.success) {
                    this.$toast.success({
                        title: 'Success',
                        message: response.message,
                        color: '#218838'
                    })  
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: response.message,
                        color: '#dc3545'
                    })
                }   
            },
            reload () {
                this.form = null
                this.search = Object.assign({}, {
                    order_id: '',
                })
            },      
            async chargeAdjust(){    
                this.loading = true     
                // const params = { id: this.form.id, status: this.form.status, reason: this.form.reason, price: this.form.price, collected: this.form.collected, service_charge: this.form.service_charge, weight_charge: this.form.weight_charge }
                const params = this.form
                const response = await config.postData('/accounts/payment/charge-adjust', params)
                this.loading = false
                if (response.status == 200){
                    this.$toast.success({
                        title: 'Success',
                        message: 'Charge calculate successfully',
                        color: '#218838'
                    }) 
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: response.message,
                        color: '#dc3545'
                    })
                }
            }
        }
    }
</script>
<style scoped>
    @media print{
        body {
            margin-left:-10px;
        }
    }
    .mt-30 {
        margin-top: 30px !important;
    }
</style>